var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("img", {
      staticClass: "ai-img",
      attrs: { src: require("../../../src/assets/image/ai.png") },
      on: {
        click: function($event) {
          return _vm.showDrawer()
        }
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowDrawer,
            expression: "isShowDrawer"
          }
        ],
        staticClass: "content"
      },
      [
        _c(
          "div",
          {
            staticClass: "div-close",
            on: {
              click: function($event) {
                return _vm.handleClose()
              }
            }
          },
          [
            _vm._v("关闭\n      "),
            _c("i", { staticClass: "el-icon-close icon-close" })
          ]
        ),
        _vm._v(" "),
        _c(
          "el-tabs",
          {
            staticStyle: { "background-color": "white" },
            attrs: { "tab-position": "right" }
          },
          [
            _c("el-tab-pane", { attrs: { label: "AI助手", name: "0" } }, [
              _c("iframe", {
                ref: "myIframe",
                staticStyle: { border: "0", height: "98vh" },
                attrs: { src: _vm.url, id: "myIframe", width: "100%" }
              })
            ]),
            _vm._v(" "),
            _c("el-tab-pane", { attrs: { label: "FAQ", name: "1" } }, [
              _c("iframe", {
                ref: "myFAQIframe",
                staticStyle: { border: "0", height: "98vh" },
                attrs: {
                  src: "https://a2-cc.callcentervip.cn/ai-kb-chat/index.html",
                  id: "myFAQIframe",
                  width: "100%"
                }
              })
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }